import { get } from '@alltrails/core/utils/get';
import { post } from '@alltrails/core/utils/post';
import type { TrailSearchResult as AlgoliaTrail } from '@alltrails/types/AlgoliaResults';
import type { Map } from '@alltrails/types/Map';
import type { TrailId } from '@alltrails/types/TrailId';
import type TrailPhoto from '@alltrails/types/TrailPhoto';

export type NearbyTrailsParams = {
  page: number;
  per_page: number;
};

export type NearbyTrailsResponse = {
  trails: AlgoliaTrail[];
};

type PhotosParams = {
  per_page: number;
};

type PhotosResponse = {
  photos: TrailPhoto[];
};

type MapsResponse = {
  maps: Map[];
};

export type CarouselResponse = {
  locations: {
    distanceTo: number;
    latitude: number;
    longitude: number;
    photo: TrailPhoto;
  }[];
};

export function getNearbyTrails(trailId: TrailId, params?: NearbyTrailsParams) {
  return get<NearbyTrailsResponse>(`/api/alltrails/v2/trails/${trailId}/nearby_trails`, { params: { ...params, algolia_formatted: true } });
}

export function getPhotos(trailId: TrailId, params?: PhotosParams) {
  return get<PhotosResponse>(`/api/alltrails/v2/trails/${trailId}/photos`, {
    params: {
      with_location: 'Y',
      per_page: params?.per_page ?? 100
    }
  }).catch();
}

export async function getCarouselPhotos(trailId: TrailId) {
  return get<CarouselResponse>(`/api/alltrails/trails/${trailId}/photos/carousel?landscape=true&limit=2`).catch();
}

export async function copyVerifiedRoute(trailId, name, detail = 'deep') {
  const response = await post<MapsResponse>(`/api/alltrails/trails/${trailId}/verified/copy`, {
    detail,
    name
  });
  return response.maps[0];
}
